import { Link } from 'react-router-dom';
import { getFeaturedArticles, getRecentArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featuredArticles = getFeaturedArticles();
  const recentArticles = getRecentArticles(3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">由专业团队精心挑选的优质内容</p>
          </div>
          <Link
            to="/category/emotional-consultation"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="flex flex-col gap-6 mb-12">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} {...article} featured />
          ))}
        </div>

        <div className="flex items-center justify-between mb-8">
          <h3 className="text-xl font-semibold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            最新发布
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {recentArticles.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>

        <div className="mt-10 text-center sm:hidden">
          <Link
            to="/category/emotional-consultation"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-lg border border-background-200/60 text-sm text-foreground-600 hover:text-foreground-800 hover:border-foreground-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}